import { render, staticRenderFns } from "./LandingMainInfo.vue?vue&type=template&id=60758ad0&scoped=true&"
import script from "./LandingMainInfo.vue?vue&type=script&lang=js&"
export * from "./LandingMainInfo.vue?vue&type=script&lang=js&"
import style0 from "./LandingMainInfo.vue?vue&type=style&index=0&id=60758ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60758ad0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingCarouselOccupation: require('/workspace/components/Landing/LandingCarouselOccupation.vue').default})
